import * as React from 'react';
import { Paper, Button, Typography, Modal, Box, Fade, CircularProgress, Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { makeStyles } from '@mui/styles';
import WorkHistoryOutlinedIcon from '@mui/icons-material/WorkHistoryOutlined';
import { Input } from 'components/layout';
import { useTranslation } from 'react-i18next';

const useStyle = makeStyles((theme) => ({
  style: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    gap: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3),
  },
  boxModalTop: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  boxModalBottom: {
    display: 'flex',
    gap: theme.spacing(2),
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

export default function ModalJobAlert({
  open,
  handleClose,
  handleConfirm,
  label='common.components.modalJob.label',
  data=null,
  workflowDefinition=null
}) {
  const classes = useStyle();
  const [t] = useTranslation();
  const methods = useForm();
  const { handleSubmit, control, setValue } = methods;
  const isWorkflowJob = !!workflowDefinition;
  let fields = [];

  const workflowHelper = (values) => {
    const jobsDefinitions = {};
    try{
      JSON.parse(workflowDefinition).forEach(wf => {
        if (wf?.length) {
          wf.forEach((i) => {
            jobsDefinitions[i.id_Plantilla] = i.id_nodo;
          });
        } else jobsDefinitions[wf.id_Plantilla] = wf;
      });
    }catch(err){}
    
    return jobsDefinitions;
  }

  const createFields = (data) => {
    let idNodes = isWorkflowJob ? workflowHelper() : {};
    
    data.forEach((item) => {
      let ui = item.user_interaction;
      if (ui === '{}' || !ui ){
        ui = '[]';
      }

      const interactions = JSON.parse(ui);

      interactions.forEach((interaction, index) => {
        let options = [];
        if (!interaction) return;

        let policy = {
          id: `${item.worktemplate_id}.${index}`,
          name: `${interaction.var_name}`,
          label: `${interaction.desc}`,
        };

        if (isWorkflowJob) policy['id_nodo'] = `${idNodes[item.worktemplate_id]}`;

        if (interaction.type === 'option') {
          policy['input'] = 'select';
          options = interaction.options.map(o => ({ value: o.value, label: o.name }));
          setValue(policy.name, options[0].value);

        } else if (interaction.type === 'number') {
          policy['input'] = 'textField';
          policy['type'] = 'number';
          policy['rules'] = {
            min: { value: interaction.range[0] },
            max: { value: interaction.range[1] }
          }
          setValue(policy.name, interaction.range[0]);
          policy.onChange = (event)=>{
            if (event.target.value<interaction.range[0])
              setValue(`${interaction.var_name}`,interaction.range[0])
            else if (event.target.value>interaction.range[1])
              setValue(`${interaction.var_name}`,interaction.range[1])
          }

        } else if (interaction.type === 'text') {
          policy['input'] = 'textField';
          setValue(policy.name, '');
        }
        fields.push({
          policy,
          options
        });
      });
    });

    return (
      <Grid container spacing={2}>
        { fields.map((field) => (
          <Grid item xs={12} sm={12} md={12} lg={12} key={field.policy.id}>
            <Input
              {...field.policy}
              control={control}
              options={field.options}
              sx={{ width: '100%' }}
            />
          </Grid>
        ))}
      </Grid>
    );
  }

  const onSubmit = (data) => {
    const fieldsMap = fields.reduce((a, v) => ({ ...a, [v.policy.name]: v}), {});
    const values = [];

    for (const key in data) {
      const field = fieldsMap[key]?.policy;
      if (field) {
        let valueToAdd = { value: data[key], name: field.name };
        if (isWorkflowJob) valueToAdd['id_nodo'] = field.id_nodo;
        values.push(valueToAdd);
      }
    }

    handleConfirm(JSON.stringify(values));
  }

  return (
    <Modal
      sx={{ backdropFilter: 'blur(2px)' }}
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Fade in={open}>
        <Paper className={classes.style}>
          <Box className={classes.boxModalTop}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              {t(label)}
            </Typography>
            <WorkHistoryOutlinedIcon color="success"/>
          </Box>

          { data ?
            (
              <>
                { createFields(data) }
              </>
            )
            :(
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <CircularProgress color="primary" />
              </Box>
            )
          }

          <Box className={classes.boxModalBottom}>
            <Button onClick={handleClose} variant="text" fullWidth>
              {t('common.components.buttons.cancel')}
            </Button>
            <Button onClick={handleSubmit(onSubmit)} variant="outlined" fullWidth>
              {t('common.components.buttons.run')}
            </Button>
          </Box>
        </Paper>
      </Fade>
    </Modal>
  );
}
